import React from 'react';
import PageContainer from '../../layout/PageContainer';
import CorredorLiquidacionList from '../liquidacion/CorredorLiquidacionList';

const CorredorGarantiaLiquidacionListContainer = () => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      { id: 1, name: 'CORREDOR', url: '/corredor/liquidacion-garantia' },
      { id: 2, name: 'LIQUIDACIÓN GARANTÍA' },
    ]}
    clientFilter={{
      type: 'corredor',
      ramo: 'garantia',
      showFilter: true,
    }}
  >
    {(corredor) => <CorredorLiquidacionList corredor={corredor} tipo="garantia" />}
  </PageContainer>
);

export default CorredorGarantiaLiquidacionListContainer;
